export default class User {
    displayName = '';
    email = '';
    uid = '';
    photoUrl = '';
    emailVerified = false;
    fulldata = {};
    phone = false;
    street = false;
    zip = false;
    city = false;
    termsAccepted = false;
    privacyAccepted = false;
    isAnonymous = null;
}